import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { IListImportAutomationClassification } from "../../../../../../models/list-import-automation-classificaton";
import { Box } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { Classification } from "./Classification/Classification";

const CLASSIFICATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListImportAutomationClassification/";
const categoryService = new MainApi<IListImportAutomationClassification>(
  CLASSIFICATION_ROUTE
);

const translationPath =
  "page.4uDlist.listImportAutomation.dlist_classifications.";

export const ClassificationPage = memo(() => {
  const { t } = useTranslation();

  const { id } = useParams();

  const [classificationForm, setClassificationForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<IListImportAutomationClassification>[] = [
    {
      field: "listClassification",
      headerName:
        t(translationPath + "list_classification") || "Classification",
      renderCell: ({ row: { listClassification } }) =>
        listClassification ? (
          <OverflowTooltip
            text={listClassification.name}
            tooltip={listClassification.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
  ];

  const handleAdd = () => {
    setClassificationForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IListImportAutomationClassification>
  ) => {
    if (!params.row) return;
    setClassificationForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setClassificationForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      ListImportAutomationId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {classificationForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Classification
            id={selectedId}
            listImportAutomationId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!classificationForm && (
        <Box height={600}>
          <Table<IListImportAutomationClassification>
            showDefaultMacroFilters={false}
            service={categoryService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            serviceProps={props}
            searchInputPlaceHolder={
              t(translationPath + "search") || "Search for a classification"
            }
            addButtonLabel={
              t(translationPath + "add_classification") || "Add Classification"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
